// extracted by mini-css-extract-plugin
export var box = "DirectionsModal-module--box--96e58";
export var box_md = "DirectionsModal-module--box_md--f515d";
export var box_xmd = "DirectionsModal-module--box_xmd--c8e4e";
export var box_flex = "DirectionsModal-module--box_flex--a5f43";
export var box_lg = "DirectionsModal-module--box_lg--6d37f";
export var box_sm = "DirectionsModal-module--box_sm--ae753";
export var box_outer = "DirectionsModal-module--box_outer--3f4e8";
export var box_whiteBg = "DirectionsModal-module--box_white-bg--60b29";
export var box_noMarginBottom = "DirectionsModal-module--box_no-margin-bottom--721f8";
export var box_noPadding = "DirectionsModal-module--box_no-padding--3528c";
export var box_outerGray = "DirectionsModal-module--box_outer-gray--98e8b";
export var box_dark = "DirectionsModal-module--box_dark--ef3f8";
export var box_zIndex = "DirectionsModal-module--box_z-index--644d8";
export var box_zIndex6 = "DirectionsModal-module--box_z-index-6--811f5";
export var box_eventsWithLine = "DirectionsModal-module--box_events-with-line--1502c";
export var box_featuresAo = "DirectionsModal-module--box_features-ao--7fd83";
export var box_verticalPaddings = "DirectionsModal-module--box_vertical-paddings--6a6f5";
export var clearP = "DirectionsModal-module--clearP--95254";
export var clearP_vc = "DirectionsModal-module--clearP_vc--9d817";
export var layout = "DirectionsModal-module--layout--0a263";
export var title = "DirectionsModal-module--title--d93f9";
export var fadeInAnimation = "DirectionsModal-module--fadeInAnimation--16f2f";
export var placeHolderShimmer = "DirectionsModal-module--placeHolderShimmer--0fd50";